// import React, { useState, useEffect, useRef } from "react";
// import styled, { createGlobalStyle } from "styled-components";
// // Framer motion is not used in the current code, but kept the import as per original request.
// // If you plan to add animations with framer-motion, you can use it.
// import { motion } from "framer-motion";

// // Path for the main banner image. Ensure this image exists in public/Images/
// const bannerImage = '/Images/image24.jpeg';

// // Global Styles for the entire application.
// const GlobalStyle = createGlobalStyle`
//   body {
//     margin: 0;
//     font-family: 'Segoe UI', sans-serif; /* Ensuring a consistent font across the page */
//     overflow-x: hidden; /* Prevent horizontal scroll on smaller screens due to carousel */
//   }

//   /* Keyframe animation for a subtle slide-down and fade-in effect */
//   @keyframes slideDownFade {
//     0% {
//       opacity: 0;
//       transform: translateY(-40px);
//     }
//     100% {
//       opacity: 1;
//       transform: translateY(0);
//     }
//   }

//   /*
//   // Removed Keyframe animation for a subtle zoom effect on the hero background image
//   @keyframes heroZoom {
//     0% {
//       background-size: 110%;
//     }
//     100% {
//       background-size: 100%;
//     }
//   }
//   */
// `;

// // Data for the new "Insights and Innovations" (Blogs) section
// const blogData = [
//   {
//     image: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&w=600&q=80', // New Image for Blockchain Solution
//     title: "Custom Blockchain Solutions for Supply Chain",
//     description: "The Internet is Revolutionizing the World, Now companies need smart solutions to improve their operations. One area where many businesses struggle is supply chain...",
//     link: "#"
//   },
//   {
//     image: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=600&q=80', // New Image for App Development
//     title: "Best App Development Services for Startups",
//     description: "In today's digital-first world, a mobile app isn't just a nice-to-have for startups it's a must. Whether you want to boost brand visibility, engage customers, or grow your revenue, a...",
//     link: "#"
//   },
//   {
//     image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=600&q=80', // New Image for Web Dev Trends
//     title: "Web Development Trends to Watch in 2025",
//     description: "The digital world is changing at lightning speed, and the way websites are built is no exception. For businesses, staying updated on the latest web development trends is crucial...",
//     link: "#"
//   },
//   {
//     image: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=600&q=80', // New Image for Machine Learning
//     title: "How Custom Machine Learning Solutions Can Transform Your...",
//     description: "AI and Machine Learning (ML) are no longer just buzzwords they're reshaping industries. They analyze massive amounts of data, automate repetitive tasks, and uncover...",
//     link: "#"
//   },
//   {
//     image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=600&q=80', // New Image for Responsive Website
//     title: "How to Create a Responsive Website for Small Businesses in 2024",
//     description: "People use all kinds of devices phones, tablets, and computers to browse the internet. That's why your small business needs a website that works smoothly on all screens.",
//     link: "#"
//   },
//   {
//     image: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&w=600&q=80', // New Image for Data Security
//     title: "Why Data Security is Non-Negotiable in Healthcare: Key Tips...",
//     description: "Let's talk about something that's becoming increasingly urgent: data security in healthcare. Did you know that in 2023, the average cost of a healthcare data breach was...",
//     link: "#"
//   }
// ];

// // Styled Component for the Hero Section (top banner)
// const HeroSection = styled.div`
//   height: 300px;
//   background-image: url(${bannerImage}); /* Dynamic background image */
//   background-size: cover;
//   background-position: center;
//   background-repeat: no-repeat;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 2px;
//   /* Removed animation: heroZoom 15s infinite alternate; */
//   position: relative;
//   overflow: hidden;

//   &::before {
//     content: "";
//     position: absolute;
//     inset: 0;
//     background-color: rgba(0, 0, 0, 0.5); /* Dark overlay */
//     backdrop-filter: blur(2px); /* Blur effect */
//     z-index: 0;
//   }
// `;

// // Styled Component for the content within the Hero Section
// const HeroContent = styled.div`
//   max-width: 100%;
//   padding: 20px;
//   color: white;
//   text-align: left;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   position: relative;
//   z-index: 1;
//   animation: slideDownFade 1.2s ease-out forwards; /* Apply slide-down fade animation */
//   opacity: 0; /* Start hidden for animation */
// `;

// // Styled Component for the main title in Hero Section
// const HeroTitle = styled.h1`
//   font-size: 2rem;
//   font-weight: 700;
//   margin-bottom: 15px;
//   @media (min-width: 768px) {
//     font-size: 3rem;
//   }
// `;

// // Styled Component for the subtitle in Hero Section
// const HeroSubtitle = styled.p`
//   font-size: 1.2rem;
//   margin-bottom: 8px;
//   @media (min-width: 768px) {
//     font-size: 1.5rem;
//   }
// `;

// // Styled Component for the description in Hero Section
// const HeroDescription = styled.p`
//   font-size: 0.9rem;
//   margin-bottom: 20px;
//   @media (min-width: 768px) {
//     font-size: 1rem;
//     max-width: 600px;
//   }
// `;

// // Styled Component for the button in Hero Section
// const HeroButton = styled.button`
//   background: linear-gradient(to right, #7e22ce, #3b82f6); /* Gradient background */
//   color: white;
//   font-weight: 600;
//   padding: 10px 25px;
//   border: none;
//   border-radius: 50px; /* Rounded corners */
//   cursor: pointer;
//   font-size: 0.9rem;
//   transition: transform 0.3s ease, box-shadow 0.3s ease;
//   &:hover {
//     transform: scale(1.05); /* Slightly enlarge on hover */
//   }
//   @media (min-width: 768px) {
//     font-size: 1rem;
//     padding: 12px 30px;
//   }
// `;

// // Styled Component for the new Blogs Section Container
// const BlogsSectionContainer = styled.div`
//   background-color: white; /* Light blue background */
//   text-align: center;
//   padding: 4rem 2rem;
// `;

// // Styled Component for the Blogs Section Title
// const BlogsSectionTitle = styled.h3`
//   font-size: 2rem;
//   margin-bottom: 3rem;
//   color:black; /* Dark text color */
//   @media (min-width: 768px) {
//     font-size: 2.5rem;
//   }
// `;

// // Styled Component for the container holding blog cards
// const BlogCardContainer = styled.div`
//   display: flex;
//   flex-wrap: wrap; /* Allow cards to wrap */
//   justify-content: center; /* Center cards horizontally */
//   gap: 2rem; /* Gap between cards */
//   max-width: 1200px; /* Max width for the card grid */
//   margin: 0 auto; /* Center the card container */
// `;

// // Styled Component for individual Blog Cards
// const BlogCard = styled.div`
//   background: #0e2147;
//   padding: 1.5rem; /* Adjusted padding */
//   border-radius: 15px;
//   box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
//   width: 300px; /* Fixed width for cards */
//   transition: transform 0.3s ease;
//   color:white; /* Changed to color directly for text */
//   text-align: left; /* Align text to left within card */
//   overflow: hidden; /* Ensure content stays within borders */

//   &:hover {
//     transform: translateY(-5px); /* Lift card on hover */
//   }

//   img {
//     width: 100%;
//     height: 180px; /* Fixed height for images */
//     object-fit: cover; /* Cover the area, crop if necessary */
//     border-radius: 10px; /* Rounded corners for image */
//     margin-bottom: 1rem;
//   }

//   h4 {
//     font-size: 1.25rem; /* Larger title */
//     margin: 0 0 0.5rem; /* Adjust margin */
//     color:white;
//   }

//   p {
//     color: white;
//     font-size: 0.95rem;
//     line-height: 1.6;
//     margin-bottom: 1rem; /* Space before button */
//   }

//   a {
//     display: inline-block;
//     margin-top: 0.5rem; /* Adjusted margin */
//     color: #007bff;
//     font-weight: bold;
//     text-decoration: none;
//     transition: color 0.3s ease;
//     &:hover {
//       text-decoration: underline;
//       color: #0056b3;
//     }
//   }

//   @media (max-width: 768px) {
//     width: 90%; /* Make cards almost full width on mobile */
//     max-width: 350px; /* Max width for mobile cards */
//   }
// `;

// // Styled Components for the Contact Section
// const ContactSection = styled.section`
//   background: white;
//   padding: 80px 20px;
//   color: white; /* This color will be overridden by inner elements if they have their own color */
// `;

// const ContactContainer = styled.div`
//   max-width: 600px;
//   margin: 0 auto;
//   display: flex;
//   flex-direction: column;
//   gap: 20px;
//   padding: 20px;
//   border-radius: 20px;
//   background: #0e2147;
//   backdrop-filter: blur(12px);
//   box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);

//   @media (min-width: 768px) {
//     flex-direction: row;
//     justify-content: space-between;
//     align-items: flex-start;
//   }
// `;

// const ContactInfo = styled.div`
//   h2 {
//     font-size: 30px;
//     margin-bottom: 20px;
//     color: white;
//   }

//   p {
//     font-size: 18px;
//     line-height: 1.7;
//     color: white;
//   }

//   @media (min-width: 768px) {
//     flex: 1;
//     padding-right: 40px;
//   }
// `;

// const ContactForm = styled.form`
//   display: flex;
//   flex-direction: column;
//   gap: 20px;

//   @media (min-width: 768px) {
//     flex: 1;
//   }
// `;

// const FormInput = styled.input`
//   padding: 16px;
//   border: none;
//   border-radius: 12px;
//   font-size: 1rem;
//   color: #333;
//   background: #fff;
//   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
//   transition: all 0.3s ease;

//   &:focus {
//     outline: none;
//     box-shadow: 0 0 0 3px rgba(75, 0, 179, 0.4);
//   }
// `;

// const FormTextarea = styled.textarea`
//   padding: 16px;
//   border: none;
//   border-radius: 12px;
//   font-size: 1rem;
//   color: #333;
//   background: #fff;
//   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
//   transition: all 0.3s ease;
//   min-height: 140px;
//   resize: vertical;

//   &:focus {
//     outline: none;
//     box-shadow: 0 0 0 3px rgba(75, 0, 179, 0.4);
//   }
// `;

// const FormButton = styled.button`
//   background-color: transparent;
//   color: white;
//   border: 1px solid white;
//   padding: 0.8rem 1.5rem;
//   font-size: 1rem;
//   cursor: pointer;
//   border-radius: 5px;
//   transition: 0.3s ease;

//   &:hover {
//     background-color: white;
//     color: #0e2147; /* Changed to match the contact form background */
//   }
// `;


// // Main IndustryCarousel React Component
// const IndustryCarousel = () => {
//   // The carousel-related state and effects are no longer needed for a static grid.
//   // Keeping `useState`, `useEffect`, `useRef` imports as they are common React hooks
//   // and might be used in other parts of a larger application or for future enhancements.

//   return (
//     <>
//       <GlobalStyle /> {/* Apply global styles */}
//       <section>
//         {/* Hero Section - Top Banner */}
//         <HeroSection>
//           <HeroContent>
//             <HeroTitle>Blogs</HeroTitle>
//             {/* <HeroSubtitle>We Serve a Diverse Range of Sectors</HeroSubtitle>
//             <HeroDescription>
//               Our experience spans a multitude of domains — from fintech to
//               manufacturing, we deliver tailored digital solutions for every
//               industry.
//             </HeroDescription>
//             <HeroButton>Explore Solutions</HeroButton> */}
//           </HeroContent>
//         </HeroSection>

//         {/* New "Insights and Innovations" (Blogs) Section */}
//         <BlogsSectionContainer>
//           <BlogsSectionTitle>Insights and Innovations: Your Gateway to IT Excellence</BlogsSectionTitle>
//           <BlogCardContainer>
//             {blogData.map((blog, index) => (
//               <BlogCard key={index}>
//                 <img src={blog.image} alt={blog.title}
//                      onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/600x400/cccccc/000000?text=Image+Not+Found'; }} />
//                 <h4>{blog.title}</h4>
//                 <p>{blog.description}</p>
//                 <a href={blog.link}>Read More</a>
//               </BlogCard>
//             ))}
//           </BlogCardContainer>
//         </BlogsSectionContainer>

//         <ContactSection>
//           <ContactContainer>
//             <ContactInfo> {/* Added ContactInfo wrapper */}
//               <h2>Contact Us</h2>

//             </ContactInfo>
//             <ContactForm>
//               <FormInput type="text" placeholder="Your Name" required />
//               <FormInput type="email" placeholder="Your Email" required />
//               <FormTextarea placeholder="Your Message" required></FormTextarea>
//               <FormButton type="submit">SEND MESSAGE</FormButton>
//             </ContactForm>
//           </ContactContainer>
//         </ContactSection>
//       </section>
//     </>
//   );
// };

// export default IndustryCarousel;

import React, { useState, useEffect, useRef } from "react";
import styled, { createGlobalStyle, keyframes } from "styled-components";
// Framer motion is not used in the current code, but kept the import as per original request.
// If you plan to add animations with framer-motion, you can use it.
import { motion } from "framer-motion";

// Path for the main banner image. Ensure this image exists in public/Images/
const bannerImage = '/Images/image26.jpeg';

// Global Styles for the entire application.
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: 'Segoe UI', sans-serif; /* Ensuring a consistent font across the page */
    overflow-x: hidden; /* Prevent horizontal scroll on smaller screens due to carousel */
  }

  /* Keyframe animation for a subtle slide-down and fade-in effect */
  @keyframes slideDownFade {
    0% {
      opacity: 0;
      transform: translateY(-40px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// Data for the new "Insights and Innovations" (Blogs) section
const blogData = [
  {
    image: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&w=600&q=80', // New Image for Blockchain Solution
    title: "Custom Blockchain Solutions for Supply Chain",
    description: "The Internet is Revolutionizing the World, Now companies need smart solutions to improve their operations. One area where many businesses struggle is supply chain...",
    link: "#"
  },
  {
    image: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=600&q=80', // New Image for App Development
    title: "Best App Development Services for Startups",
    description: "In today's digital-first world, a mobile app isn't just a nice-to-have for startups it's a must. Whether you want to boost brand visibility, engage customers, or grow your revenue, a...",
    link: "#"
  },
  {
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=600&q=80', // New Image for Web Dev Trends
    title: "Web Development Trends to Watch in 2025",
    description: "The digital world is changing at lightning speed, and the way websites are built is no exception. For businesses, staying updated on the latest web development trends is crucial...",
    link: "#"
  },
  {
    image: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=600&q=80', // New Image for Machine Learning
    title: "How Custom Machine Learning Solutions Can Transform Your...",
    description: "AI and Machine Learning (ML) are no longer just buzzwords they're reshaping industries. They analyze massive amounts of data, automate repetitive tasks, and uncover...",
    link: "#"
  },
  {
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=600&q=80', // New Image for Responsive Website
    title: "How to Create a Responsive Website for Small Businesses in 2024",
    description: "People use all kinds of devices phones, tablets, and computers to browse the internet. That's why your small business needs a website that works smoothly on all screens.",
    link: "#"
  },
  {
    image: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&w=600&q=80', // New Image for Data Security
    title: "Why Data Security is Non-Negotiable in Healthcare: Key Tips...",
    description: "Let's talk about something that's becoming increasingly urgent: data security in healthcare. Did you know that in 2023, the average cost of a healthcare data breach was...",
    link: "#"
  }
];

// Styled Component for the Hero Section (top banner)
const HeroSection = styled.div`
  height: 300px;
  background-image: url(${bannerImage}); /* Dynamic background image */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Dark overlay */
    backdrop-filter: blur(2px); /* Blur effect */
    z-index: 0;
  }
`;

// Styled Component for the content within the Hero Section
const HeroContent = styled.div`
  max-width: 100%;
  padding: 20px;
  color: white;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  z-index: 1;
  animation: slideDownFade 1.2s ease-out forwards; /* Apply slide-down fade animation */
  opacity: 0; /* Start hidden for animation */
`;

// Styled Component for the main title in Hero Section
const HeroTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 15px;
  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

// Styled Component for the subtitle in Hero Section
const HeroSubtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 8px;
  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

// Styled Component for the description in Hero Section
const HeroDescription = styled.p`
  font-size: 0.9rem;
  margin-bottom: 20px;
  @media (min-width: 768px) {
    font-size: 1rem;
    max-width: 600px;
  }
`;

// Styled Component for the button in Hero Section
const HeroButton = styled.button`
  background: linear-gradient(to right, #7e22ce, #3b82f6); /* Gradient background */
  color: white;
  font-weight: 600;
  padding: 10px 25px;
  border: none;
  border-radius: 50px; /* Rounded corners */
  cursor: pointer;
  font-size: 0.9rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: scale(1.05); /* Slightly enlarge on hover */
  }
  @media (min-width: 768px) {
    font-size: 1rem;
    padding: 12px 30px;
  }
`;

// Styled Component for the new Blogs Section Container
const BlogsSectionContainer = styled.div`
  background-color: white; /* Light blue background */
  text-align: center;
  padding: 4rem 2rem;
`;

// Styled Component for the Blogs Section Title
const BlogsSectionTitle = styled.h3`
  font-size: 2rem;
  margin-bottom: 3rem;
  color:black; /* Dark text color */
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
`;

// Styled Component for the container holding blog cards
const BlogCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap; /* Allow cards to wrap */
  justify-content: center; /* Center cards horizontally */
  gap: 2rem; /* Gap between cards */
  max-width: 1200px; /* Max width for the card grid */
  margin: 0 auto; /* Center the card container */
`;

// Styled Component for individual Blog Cards
const BlogCard = styled.div`
  background: #0e2147;
  padding: 1.5rem; /* Adjusted padding */
  border-radius: 15px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
  width: 300px; /* Fixed width for cards */
  transition: transform 0.3s ease;
  color:white; /* Changed to color directly for text */
  text-align: left; /* Align text to left within card */
  overflow: hidden; /* Ensure content stays within borders */

  &:hover {
    transform: translateY(-5px); /* Lift card on hover */
  }

  img {
    width: 100%;
    height: 180px; /* Fixed height for images */
    object-fit: cover; /* Cover the area, crop if necessary */
    border-radius: 10px; /* Rounded corners for image */
    margin-bottom: 1rem;
  }

  h4 {
    font-size: 1.25rem; /* Larger title */
    margin: 0 0 0.5rem; /* Adjust margin */
    color:white;
  }

  p {
    color: white;
    font-size: 0.95rem;
    line-height: 1.6;
    margin-bottom: 1rem; /* Space before button */
  }

  a {
    display: inline-block;
    margin-top: 0.5rem; /* Adjusted margin */
    color: #007bff;
    font-weight: bold;
    text-decoration: none;
    transition: color 0.3s ease;
    &:hover {
      text-decoration: underline;
      color: #0056b3;
    }
  }

  @media (max-width: 768px) {
    width: 90%; /* Make cards almost full width on mobile */
    max-width: 350px; /* Max width for mobile cards */
  }
`;

// Styled Components for the Contact Section
const ContactSection = styled.section`
  background: white;
  padding: 80px 20px;
  color: white; /* This color will be overridden by inner elements if they have their own color */
`;

const ContactContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border-radius: 20px;
  background: #0e2147;
  backdrop-filter: blur(12px);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const ContactInfo = styled.div`
  h2 {
    font-size: 30px;
    margin-bottom: 20px;
    color: white;
  }

  p {
    font-size: 18px;
    line-height: 1.7;
    color: white;
  }

  @media (min-width: 768px) {
    flex: 1;
    padding-right: 40px;
  }
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 768px) {
    flex: 1;
  }
`;

const FormInput = styled.input`
  padding: 16px;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  color: #333;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(75, 0, 179, 0.4);
  }
`;

const FormTextarea = styled.textarea`
  padding: 16px;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  color: #333;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  min-height: 140px;
  resize: vertical;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(75, 0, 179, 0.4);
  }
`;

const FormButton = styled.button`
  background-color: transparent;
  color: white;
  border: 1px solid white;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.3s ease;

  &:hover {
    background-color: white;
    color: #0e2147; /* Changed to match the contact form background */
  }
`;

// Clients Section Styled Components
const scrollAnimation = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-500%);
  }
`;

const ClientsSectionContainer = styled.div`
  text-align: center;
  background: linear-gradient(135deg, #0e2147, #0e2147);
  padding: 60px 20px;
  overflow: hidden;
  position: relative;
`;

const ClientsSectionTitle = styled.h2`
  font-size: 2.5rem;
  color: white;
  margin-bottom: 40px;
  font-weight: 600;
`;

const Highlight = styled.span`
  color: #0053d8;
`;

const LogosSlider = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
`;

const LogosTrack = styled.div`
  display: flex;
  animation: ${scrollAnimation} 10s linear infinite;
  
`;

const LogoCard = styled.div`
  flex: 0 0 auto;
  margin: 0 15px;
  background: #fff;
  border-radius: 50px;
  padding: 20px 40px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.1s ease;
`;

const LogoImage = styled.img`
  height: 40px;
  object-fit: contain;
`;

// Data for client logos. Using lowercase 'images' for paths.
// Data for client logos using public CDN links (Wikimedia Commons)
const logos = [
  { src: "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png", alt: "Google Logo" },
  { src: "https://1000logos.net/wp-content/uploads/2017/03/Nike-Logo.png", alt: "Nike Logo" },
  { src: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Apple_logo_black.svg/1024px-Apple_logo_black.svg.png", alt: "Apple Logo" },
  { src: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/1024px-Microsoft_logo_%282012%29.svg.png", alt: "Microsoft Logo" },
//   { src: "https://1000logos.net/wp-content/uploads/2017/08/Starbucks-logo.png", alt: "Starbucks Logo" },
  { src: "https://1000logos.net/wp-content/uploads/2016/10/Amazon-logo-meaning.jpg", alt: "Amazon Logo" },
  { src: "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png", alt: "Facebook Logo" },
];



// ClientsSection Functional Component (now integrated)
const ClientsSection = () => {
  return (
    <ClientsSectionContainer>
      <ClientsSectionTitle>
        Join Our <Highlight>100+</Highlight> Happy Clients
      </ClientsSectionTitle>
      <LogosSlider>
        <LogosTrack>
          {logos.concat(logos).map((logo, index) => (
            <LogoCard key={index}>
              <LogoImage src={logo.src} alt={logo.alt} />
            </LogoCard>
          ))}
        </LogosTrack>
      </LogosSlider>
    </ClientsSectionContainer>
  );
};


// Main IndustryCarousel React Component (now representing the whole page)
const IndustryCarousel = () => {
  // The carousel-related state and effects are no longer needed for a static grid.
  // Keeping `useState`, `useEffect`, `useRef` imports as they are common React hooks
  // and might be used in other parts of a larger application or for future enhancements.

  return (
    <>
      <GlobalStyle /> {/* Apply global styles */}
      <section>
        {/* Hero Section - Top Banner */}
        <HeroSection>
          <HeroContent>
            <HeroTitle>Blogs</HeroTitle>
            {/* The commented-out subtitle, description, and button can be uncommented if needed */}
            {/* <HeroSubtitle>We Serve a Diverse Range of Sectors</HeroSubtitle>
            <HeroDescription>
              Our experience spans a multitude of domains — from fintech to
              manufacturing, we deliver tailored digital solutions for every
              industry.
            </HeroDescription>
            <HeroButton>Explore Solutions</HeroButton> */}
          </HeroContent>
        </HeroSection>

        {/* New "Insights and Innovations" (Blogs) Section */}
        <BlogsSectionContainer>
          <BlogsSectionTitle>Insights and Innovations: Your Gateway to IT Excellence</BlogsSectionTitle>
          <BlogCardContainer>
            {blogData.map((blog, index) => (
              <BlogCard key={index}>
                <img src={blog.image} alt={blog.title}
                  onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/cccccc/000000?text=Image+Not+Found'; }} />
                <h4>{blog.title}</h4>
                <p>{blog.description}</p>
                <a href={blog.link}>Read More</a>
              </BlogCard>
            ))}
          </BlogCardContainer>
        </BlogsSectionContainer>

        {/* Clients Section - Integrated */}
        <ClientsSection />

        {/* Contact Section */}
        <ContactSection>
          <ContactContainer>
            <ContactInfo> {/* Added ContactInfo wrapper */}
              <h2>Contact Us</h2>
            </ContactInfo>
            <ContactForm>
              <FormInput type="text" placeholder="Your Name" required />
              <FormInput type="email" placeholder="Your Email" required />
              <FormTextarea placeholder="Your Message" required></FormTextarea>
              <FormButton type="submit">SEND MESSAGE</FormButton>
            </ContactForm>
          </ContactContainer>
        </ContactSection>
      </section>
    </>
  );
};

export default IndustryCarousel;